import { render, staticRenderFns } from "./checkPrice.vue?vue&type=template&id=6767d270&scoped=true&"
import script from "./checkPrice.vue?vue&type=script&lang=js&"
export * from "./checkPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6767d270",
  null
  
)

export default component.exports